module.exports = __webpack_public_path__ + "img/support.8d7a72aa.jpg";